<template>
  <div class="Inspection2">
    <h1 id="heading">Bewertung der Anzahl der Überrollungen pro Jahr</h1>
    <v-divider></v-divider>
    <v-container style="margin-left: 5%;">
      <v-layout>
        <v-flex>
          <div class="description">
            <v-dialog v-model="dialogV" max-width="500px" :retain-focus="false">
              <template v-slot:activator="{ on }">
                <v-btn color="green" slot="activator" v-on="on" x-small fab>
                  <v-icon color="white" small>fas fa-info</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar color="green" height="50px">
                  <v-toolbar-title style="color: white; font-size: 130%">Anzahl der Überrollungen des Tragseils pro Fahrt</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-btn small @click="closeV" icon>
                    <v-icon color="white">fas fa-times</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-card-text style="font-size: 100%;">
                  <p
                    class="paramDesc"
                  >Zählen Sie die Anzahl der Fahrzeuge multipliziert mit der Anzahl der Laufrollen je Fahrzeug (auf
das zu bewertende Tragseil bezogen).</p>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <v-text-field
            class="txtField"
            outlined
            name="vehicleAmount"
            v-model="vehicle"
            label="Anzahl der Überrollungen des Tragseils pro Fahrt"
            placeholder
            type="number"
            step="1"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <div class="description">
            <v-dialog v-model="dialogR" max-width="500px" :retain-focus="false">
              <template v-slot:activator="{ on }">
                <v-btn color="green" slot="activator" v-on="on" x-small fab>
                  <v-icon color="white" small>fas fa-info</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar color="green" height="50px">
                  <v-toolbar-title style="color: white; font-size: 150%">Geschwindigkeit</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-btn small @click="closeR" icon>
                    <v-icon color="white">fas fa-times</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-card-text style="font-size: 100%;">
                  <p class="paramDesc">Durchschnittliche Geschwindigkeit, in Meter pro Sekunde [m/s]</p>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <v-text-field
            class="txtField"
            outlined
            name="rollAmount"
            v-model="roll"
            label="Geschwindigkeit"
            placeholder
            type="number"
            step="1"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <div class="description">
            <v-dialog v-model="dialogDU" max-width="500px" :retain-focus="false">
              <template v-slot:activator="{ on }">
                <v-btn color="green" slot="activator" x-small fab v-on="on">
                  <v-icon color="white" small>fas fa-info</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar color="green" height="50px">
                  <v-toolbar-title style="color: white; font-size: 150%">Seillänge</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-btn small @click="closeDU" icon>
                    <v-icon color="white">fas fa-times</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-card-text style="font-size: 100%;">
                  <p class="paramDesc">Seillänge in Meter [m]</p>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <v-text-field
            class="txtField"
            outlined
            name="circulationTime"
            v-model="circTime"
            label="Seillänge"
            placeholder
            type="number"
            step="1"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <div class="description">
            <v-dialog v-model="dialogZ" max-width="500px" :retain-focus="false">
              <template v-slot:activator="{ on }">
                <v-btn color="green" slot="activator" x-small fab v-on="on">
                  <v-icon color="white" small>fas fa-info</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar color="green" height="50px">
                  <v-toolbar-title style="color: white; font-size: 150%">Betriebsstunden pro Jahr</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-btn small @click="closeZ" icon>
                    <v-icon color="white">fas fa-times</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-card-text style="font-size: 100%;">
                  <p class="paramDesc">Betriebsstunden pro Jahr [Std/J]<br><br>
                  Geben Sie den höchsten Wert der letzten Jahre ein!</p>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <v-text-field
            class="txtField"
            outlined
            name="operatingHours"
            v-model="operatingH"
            label="Betriebsstunden pro Jahr"
            placeholder
            type="number"
              step="1"
          ></v-text-field>
        </v-flex>
        <v-flex style="margin-top: 4%; margin-right: 10%;">
          <v-btn color="blue" @click="calculate" fab>
            <v-icon color="white">fas fa-calculator</v-icon>
          </v-btn>
          <div style="display: block; text-align: center;">
            berechnen
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <h2>Überrollungen/Jahr: {{result}}</h2>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider></v-divider>
    <div>
      <v-data-table
        :headers="headers"
        :items-per-page="5"
        :items="items"
        item-key="name"
        class="DataTable"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.name }}</td>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.assess }}</td>
            <td>
              <input
                type="radio"
                v-model="assessment"
                :key="props.item.assess"
                :value="props.item.assess"
                @click="manualSelected(true);"
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="description">
        <v-dialog v-model="dialog" max-width="500px" :retain-focus="false">
          <template v-slot:activator="{ on }">
            <v-btn color="green" slot="activator" v-on="on" x-small fab>
              <v-icon color="white" small>fas fa-info</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar color="green" height="50px">
              <v-toolbar-title
                style="color: white; font-size: 150%"
              >Anzahl der Überrollungen pro Jahr</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn small @click="close" icon>
                <v-icon color="white">fas fa-times</v-icon>
              </v-btn>
            </v-toolbar>
            <v-img src="../../statics/images/Vergusskegel2.png" height="200px"></v-img>

            <v-card-text style="font-size: 100%;">
              <p>Zählen Sie die Anzahl der Fahrzeuge multipliziert mit der Anzahl der Rollen pro Fahrzeug und
multiplizieren Sie diese mit der Anzahl der Fahrten pro Jahr für jedes Tragseil einzeln.</p>
              <br>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <v-divider></v-divider>
      <v-btn color="blue" @click="nextPage" small fab>
        <v-icon color="white">fas fa-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Inspection2",
  props: ["assessmen"],
  data() {
    return {
      manualSelect: false,
      assessment: 0,
      isInsp2: false,
      vehicle: "",
      roll: "",
      cycle: "",
      circTime: "",
      operatingH: "",
      result: 0,
      dialog: false,
      assessName: "",
      dialogV: false,
      dialogR: false,
      dialogZ: false,
      dialogDU: false,
      caseSBahn: false,
      caseNot: false,
      qDone: true,
      assessHeader: "",
      items: [
        { name: "Unter 100.000", assess: 0 },
        { name: "100.000 bis 500.000", assess: 1 },
        { name: "Über 500.000", assess: 2 }
      ],
      headers: [
        {
          text: "Überrrollungen pro Jahr",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Relative Bewertung", sortable: false, value: "assess" }
      ]
    };
  },
  methods: {
    manualSelected(val){
      this.manualSelect = val;
    },
    nextPage() {
      switch (this.assessment) {
        case 0:
          this.assessName = "Unter 100000";
          break;
        case 1:
          this.assessName = "100000 bis 500000";
          break;
        case 2:
          this.assessName = "Über 500000";
          break;
      }
      this.assessmen = this.assessmen + this.assessment;
      this.assessHeader = "Anzahl der Überrollungen";

      // isInsp2 = true;

      this.$emit("assessChanged", this.assessmen);
      if (!this.manualSelect) {
        this.$emit("assessmentName", this.assessName + "  (Anzahl der Überrollungen des Tragseils pro Fahrt: " + this.vehicle + " Überrollungen | Betriebsstunden: " + this.operatingH + " h | Geschwindigkeit: " + this.roll + " m/s | Seillänge: " + this.circTime + " m)");
      } else {
        this.$emit("assessmentName", "manuelle Punktevergabe - " + this.assessName);
      }
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      // this.$emit("prevPage2", this.isInsp2);
      this.$emit("prevPage1", false);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    },
    calculate() {
      this.manualSelected(false);
      var helpRes = this.roll * 3600 * this.operatingH;
      this.result = helpRes / this.circTime * this.vehicle;
      this.result = this.result.toFixed(0);
      this.assessName += "  (Anzahl der Überrollungen des Tragseils pro Fahrt: " + this.roll + " | Fahrzeuge: " + this.vehicle + " | Zyklen pro Tag: " + this.cycle;

      if (this.result < 100000) {
        this.assessment = 0;
      }
      if (this.result > 100000 && this.result < 500000) {
        this.assessment = 1;
      }
      if (this.result > 500000) {
        this.assessment = 2;
      }
    },
    close() {
      this.dialog = false;
    },
    closeV() {
      this.dialogV = false;
    },
    closeR() {
      this.dialogR = false;
    },
    closeZ() {
      this.dialogZ = false;
    },
    closeDU() {
      this.dialogDU = false;
    },
    showN() {
      this.caseNot = true;
      this.qDone = false;
    },
    showS() {
      this.caseSBahn = true;
      this.qDone = false;
    }
  },
  created() {
    var ropeType = this.$store.state.facilityList.find(x => x.id == this.$store.state.inspectingFacilityID).ropeList.find(x => x.id == this.$store.state.inspectingRopeID).rope;
    if (ropeType.includes("Litzenseil")) {
      this.assessment = 0;
      this.$emit("assessChanged", this.assessmen);
      this.$emit("assessmentName", this.assessName);
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    }
  }
};
</script>

<style>
.Inspection2 {
  background-color: white;
  width: 90%;
  margin: 1% auto 0% auto;
  border: 1px solid black;
  border-radius: 5px;
  text-align: center;
}

.radioGroup {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30%;
}

.DataTable {
  width: 90%;
  margin-left: 5%;
}

#heading {
  font-size: 200%;
}
</style>
